import React from 'react'
import PropTypes from 'prop-types'

import {
  UI_LABEL_ADVISOR,
  UI_LABEL_INVESTOR,
  SERVICE_LABEL_ADVISOR,
  SERVICE_LABEL_INVESTOR,
} from '../Landing/Helper/constants.js'

function Step0({ handleOptionChange, selectedOption }) {
  return (
    <div className="u-paddingHoriz6gu u-paddingTop8gu u-sm-sizeFull">
      <h2 className="u-marginBottom4gu">Manage your Subscriptions</h2>
      <p className="u-marginBottom3gu">
        Please enter your information to access the subscription center.
      </p>
      <div className="Radio u-flex u-flexAlignItemsCenter u-paddingTop2gu">
        <h5 className="u-textSizeMsr u-textNoTransform u-marginBottom3gu">
          I am a(n):
        </h5>
        <input
          name="role"
          id="role1"
          type="radio"
          value={SERVICE_LABEL_ADVISOR}
          checked={selectedOption === SERVICE_LABEL_ADVISOR}
          onChange={handleOptionChange}
          className="Radio-button"
          data-analytics="cesc-Advisor"
        />
        <label
          htmlFor="role1"
          className="Radio-label u-marginBottom3gu u-marginLeft3gu"
        >
          {UI_LABEL_ADVISOR}
        </label>
        <input
          name="role"
          id="role2"
          type="radio"
          value={SERVICE_LABEL_INVESTOR}
          checked={selectedOption === SERVICE_LABEL_INVESTOR}
          onChange={handleOptionChange}
          className="Radio-button"
          data-analytics="cesc-Investor"
        />
        <label
          htmlFor="role2"
          className="Radio-label u-marginBottom3gu u-marginLeft3gu"
        >
          {UI_LABEL_INVESTOR}
        </label>
      </div>
    </div>
  )
}

Step0.propTypes = {
  handleOptionChange: PropTypes.func.isRequired,
  selectedOption: PropTypes.string,
}

export default Step0
